(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recommend"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".recommend>div");
    if (productRecommendationsSection === null) { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = "/recommendations/products?section_id=recommend&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".recommend>div").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "recommend") {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection();
  document.querySelector('.recommend').addEventListener('click', function (event) {
    if (event.target.closest('button') && document.querySelector('.recommend').contains(event.target)) {
      window.toggleFavorite(event.target.closest('button'));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
